<div class="print-container">
    <h1 class="page-label">Carton Audit - Select Location / Service</h1>
</div>
<div class="tab-pane">
    <div>
        <div class="print-container">
            <div class="row">
                <div class="col-sm-3" style="text-align:right">
                <label class=" input-label" for="portal-input">Location / Service:</label>
                
                  </div>  
                  <div class="col-sm-6">
                <select [(ngModel)]="selectedService" class="form-control" id="service-input" [disabled]="isUiDisabled">
                <option [ngValue]="null"> -- Choose -- </option>
                <option *ngFor="let service of availableServices" [ngValue]="service">
                    {{ service.name }}
                </option>
            </select>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="onSelectServiceClicked()" class="submit btn btn-primary col-sm-3" [disabled]="isUiDisabled">
            SELECT SERVICE
        </button>
    </div>
</div>



<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>